import {CountryMutation} from "./types";
import {STATUS_ERROR, STATUS_LOADING, STATUS_SUCCESS} from "../const";

export default {
    [CountryMutation.REQUEST](state) {
        state.status = STATUS_LOADING;
        state.items = [];
    },
    [CountryMutation.SUCCESS_AUTOCOMPLETE](state, items) {
        state.status = STATUS_SUCCESS;
        state.autocomplete = items;
    },
    [CountryMutation.ERROR](state, error) {
        state.status = STATUS_ERROR;
        state.lastError = error;
        state.items = [];
    },
};